import { Component, Input, OnChanges, OnDestroy, OnInit, SecurityContext, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription, takeWhile } from 'rxjs';
import { appConstants } from '../../../../shared/constants/app-constants';
import { IUser } from '../../../../shared/models/user';
import { AuthService } from '../../../../shared/services/auth.service';
import { UserUtility } from '../../../../shared/utilities/user-utility';
import { ICommittee } from '../../shared/models/committee';
import { ILiaison } from '../../shared/models/liason';

@Component({
    selector: 'app-committee-details-overview',
    templateUrl: './committee-details-overview.component.html',
    styleUrl: './committee-details-overview.component.scss',
    standalone: false
})
export class CommitteeDetailsOverviewComponent implements OnInit, OnDestroy, OnChanges {
  @Input() committee: ICommittee | null = null;

  @Input() loading: boolean = true;
  subscriptions: Subscription = new Subscription();

  currentUser: IUser | null = null;
  canViewAllCommitteeDetails: boolean = false;

  liasonDetailsFrom: ILiaison[] = [];
  liasonDetailsTo: ILiaison[] = [];
  sanitizedTermsOfReference: string = '';

  constructor(
    private _authService: AuthService,
    private _sanitizer: DomSanitizer
  ) {
  }

  ngOnInit(): void {
    const userSubscription = this._authService.currentUserSubject
      .pipe(
        takeWhile(() => this.currentUser == null)
      )
      .subscribe(user => {
        if (user) {
          this.currentUser = user;
          this.initialize();
        }
      });

    this.subscriptions.add(userSubscription);
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes['committee'] && changes['committee'].currentValue && !changes['committee'].firstChange) {
      this.committee = changes['committee'].currentValue;
      this.initialize();
    }
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  initialize() {
    if (!this.committee || !this.currentUser) {
      return;
    }

    this.initializeCanViewAllCommitteeDetails();
    this.initializeTermsOfReference();
    this.initializeLiasonDetails();
  }

  initializeCanViewAllCommitteeDetails() {
    if (this.currentUser && this.committee) {
      this.canViewAllCommitteeDetails = UserUtility.isInternalUser(this.currentUser)
        || UserUtility.userIsOnCommittee(this.currentUser, this.committee.committeeCode);
    }
  }

  initializeTermsOfReference() {
    if (this.committee?.termOfReference) {
      this.sanitizedTermsOfReference = this._sanitizer.sanitize(SecurityContext.HTML, this.committee.termOfReference) ?? '';
    }
  }

  initializeLiasonDetails() {
    if (this.canViewAllCommitteeDetails && this.committee?.liaisonDetails) {
      this.liasonDetailsFrom = this.committee.liaisonDetails.filter(x => x.liaisonType === appConstants.liasonTypes.from);
      this.liasonDetailsTo = this.committee.liaisonDetails.filter(x => x.liaisonType === appConstants.liasonTypes.to);
    }
  }

  isShowingField(value: string) {
    if(value) {
      let trimmedText = value?.replace(/\s/g, '');
      return this.canViewAllCommitteeDetails && trimmedText.length > 0;
    }
    return false;
  }

}
